module.exports = __webpack_public_path__ + "static/img/7变位内齿轮和正齿轮的计算.7c00535b.jpg";